import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-3"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_5 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center",
  style: {"min-height":"200px","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_7 = {
  key: 2,
  class: "d-flex flex-column gap-3"
}
const _hoisted_8 = {
  for: "igv-url-select",
  class: "form-label"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-0"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "table-scroll-x" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 6,
  class: "code-highlight"
}

import { computed, ref, onMounted } from 'vue';
import { DataObjectType } from '@/gql/graphql';
import {
  BAlert,
  BBadge,
  BButton,
  BForm,
  BFormSelect,
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BTooltip,
} from 'bootstrap-vue-next';
import Papa from 'papaparse';
import { formatFileSize, formatFileName } from '@/utils/file-utils';
import { formatDateTime } from '@/utils/date-utils';
import { getFileDownloadUrl } from '@/utils/fileService';
import {
  highlightJson,
  highlightLog,
  highlightPython,
  highlightShell,
} from '@/utils/prism-utils';
import { PAGING_ITEMS_PER_PAGE } from '@/constants';

// --- Component properties ---
const igvRemoteUrl = 'https://igv.org/app';
const igvLocalUrl = 'http://localhost:60151/load';

export default /*@__PURE__*/_defineComponent({
  __name: 'DataObjectDetail',
  props: {
    show: { type: Boolean },
    dataObject: {},
    bucketName: {},
    bucketId: {},
    allowDownload: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component state ---
const downloadUrl = ref<string | null>(null);
const igvUrl = ref(igvLocalUrl);
const igvUrlOptions = ref<Array<{ value: string; text: string }>>([
  { value: igvLocalUrl, text: 'IGV Desktop (recommended)' },
  { value: igvRemoteUrl, text: 'IGV Web (igv.org)' },
]);
const igvNoPhiConfirmed = ref<boolean>(false);
const igvGenome = ref('hg38');
const igvLocus = ref<string | null>('');
const igvGenomeOptions = ref<Array<{ value: string; text: string }>>([
  { value: 'hg19', text: 'Human (hg19)' },
  { value: 'hg38', text: 'Human (hg38)' },
  { value: 'mm10', text: 'Mouse (mm10)' },
  { value: 'rn6', text: 'Rat (rn6)' },
  { value: 'dm6', text: 'Drosophila (dm6)' },
  { value: 'ce11', text: 'C. elegans (ce11)' },
  { value: 'sacCer3', text: 'Yeast (sacCer3)' },
  { value: 'custom', text: 'Custom (provide URL in IGV)' },
]);
const remoteIgvUrlSelected = computed(() => igvUrl.value === igvRemoteUrl);
const localIgvUrlSelected = computed(() => igvUrl.value === igvLocalUrl);
const showIgvDesktopInstructions = ref(false);
const showIgvAdditionalUrls = computed(
  () => remoteIgvUrlSelected.value && igvAdditionalUrls.value.length > 0
);
const igvAdditionalUrls = ref<Array<{ value: string; text: string }>>([]);

// --- Component emits ---
const emits = __emit;

const show = computed<boolean>(() => {
  return props.show;
});

const sizeIsFitForPreview = computed(() => {
  if (!props.dataObject.size) {
    return true;
  }
  return props.dataObject.size.length < 8;
});
const isTextFile = computed(() => {
  return (
    props.dataObject.contentType?.toLowerCase().startsWith('text/') ||
    props.dataObject.name?.toLowerCase().endsWith('.html') ||
    props.dataObject.name?.toLowerCase().endsWith('.css') ||
    props.dataObject.name?.toLowerCase().endsWith('.js') ||
    props.dataObject.name?.toLowerCase().endsWith('.json') ||
    props.dataObject.name?.toLowerCase().endsWith('.xml') ||
    props.dataObject.name?.toLowerCase().endsWith('.yml') ||
    props.dataObject.name?.toLowerCase().endsWith('.yaml') ||
    props.dataObject.name?.toLowerCase().endsWith('.md') ||
    props.dataObject.name?.toLowerCase().endsWith('.txt') ||
    props.dataObject.name?.toLowerCase().endsWith('.csv') ||
    props.dataObject.name?.toLowerCase().endsWith('.tsv') ||
    props.dataObject.name?.toLowerCase().endsWith('.log') ||
    props.dataObject.name?.toLowerCase().endsWith('.sh') ||
    props.dataObject.name?.toLowerCase().endsWith('.bat') ||
    props.dataObject.name?.toLowerCase().endsWith('.ps1') ||
    props.dataObject.name?.toLowerCase().endsWith('.py') ||
    props.dataObject.name?.toLowerCase().endsWith('.graphql') ||
    props.dataObject.name?.toLowerCase().endsWith('.gql') ||
    props.dataObject.name?.toLowerCase().endsWith('.sql') ||
    props.dataObject.name?.toLowerCase().endsWith('.ts') ||
    props.dataObject.name?.toLowerCase().endsWith('.rb') ||
    props.dataObject.name?.toLowerCase().endsWith('.php') ||
    props.dataObject.name?.toLowerCase().endsWith('.java') ||
    props.dataObject.name?.toLowerCase().endsWith('.c') ||
    props.dataObject.name?.toLowerCase().endsWith('.cpp')
  );
});
const canPreviewInNewTab = computed(() => {
  return (
    props.allowDownload &&
    (isHtmlFile.value || isImageFile.value || isPdf.value)
  );
});
const isHtmlFile = computed(() => {
  if (props.dataObject && props.dataObject.name) {
    const name = props.dataObject.name.toLowerCase();
    const type = props.dataObject.contentType
      ? props.dataObject.contentType.toLowerCase()
      : '';
    return name.endsWith('.html') || type.includes('text/html');
  }
  return false;
});
const isImageFile = computed(() => {
  return (
    props.dataObject.contentType?.toLowerCase().startsWith('image/') ||
    props.dataObject.name?.toLowerCase().endsWith('.png') ||
    props.dataObject.name?.toLowerCase().endsWith('.jpg') ||
    props.dataObject.name?.toLowerCase().endsWith('.jpeg') ||
    props.dataObject.name?.toLowerCase().endsWith('.bmp') ||
    props.dataObject.name?.toLowerCase().endsWith('.svg')
  );
});
const isIgv = computed(
  () =>
    props.dataObject.name?.toLowerCase().endsWith('.bam') ||
    props.dataObject.name?.toLowerCase().endsWith('.vcf') ||
    props.dataObject.name?.toLowerCase().endsWith('.vcf.gz')
);
const isBam = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.bam')
);
const isVcf = computed(
  () =>
    props.dataObject.name?.toLowerCase().endsWith('.vcf') ||
    props.dataObject.name?.toLowerCase().endsWith('.vcf.gz')
);
const isPdf = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.pdf')
);
const isCsv = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.csv')
);
const isTsv = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.tsv')
);
const isJson = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.json')
);
const isPython = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.py')
);
const isLog = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.log')
);
const isShell = computed(() =>
  props.dataObject.name?.toLowerCase().endsWith('.sh')
);
const previewEmbedded = computed(
  () =>
    props.allowDownload &&
    sizeIsFitForPreview.value &&
    !isHtmlFile.value &&
    (isTextFile.value || isImageFile.value)
);
const isDelimitedFile = computed(() => isCsv.value || isTsv.value);

// Formatted json
const formattedJson = computed(() => {
  try {
    // If fileContent is a string, parse it. If it’s already an object, use it directly.
    const obj =
      typeof fileContent.value === 'string'
        ? JSON.parse(fileContent.value)
        : fileContent.value;
    return obj; // JSON.stringify(obj, null, 2);
  } catch (e) {
    // If parsing fails, return the original content.
    return fileContent.value;
  }
});

// Parsed CSV/TSV state
const parsedFields = ref<any[]>([]);
const parsedItems = ref<any[]>([]);

const paginatedItems = computed(() => {
  const startIndex = (pagingPageCurrent.value - 1) * pagingItemsPerPage.value;
  const endIndex = pagingPageCurrent.value * pagingItemsPerPage.value;
  return parsedItems.value.slice(startIndex, endIndex);
});

const pagingPageCurrent = ref(1);
const pagingItemsPerPage = ref(PAGING_ITEMS_PER_PAGE);
const pagingTotalRows = computed(() => {
  return parsedItems.value.length || 0;
});

// --- Component methods ---
const fileContent = ref<string>('');
const loadingContent = ref<boolean>(false);
const errorContent = ref<string | null>(null);

onMounted(async () => {
  // Check if the file preview is presentable (text or image)
  if (props.dataObject.name && props.allowDownload) {
    loadingContent.value = true;
    try {
      // Get download URL
      downloadUrl.value = await getFileDownloadUrl(
        props.bucketId,
        props.dataObject.name
      );
      // validate URL
      if (!downloadUrl.value) {
        throw new Error(
          'Failed to obtain the file for download. The file might not be available anymore.'
        );
      }
      // Fetch content if preview is embedded
      if (previewEmbedded.value) {
        const response = await fetch(downloadUrl.value);
        if (!response.ok) {
          throw new Error('Failed to fetch file content.');
        }
        // Plain text content
        fileContent.value = await response.text();
        // If it's a CSV or TSV file, parse the content
        if (isDelimitedFile.value) {
          const parseResult = Papa.parse(fileContent.value, {
            header: true,
            delimiter: isCsv.value ? ',' : '\t',
            skipEmptyLines: true,
          });
          // PapaParse returns data and meta.headers
          parsedFields.value = (parseResult.meta.fields || []).map(
            (header: string) => ({
              key: header,
              label: header,
            })
          );
          parsedItems.value = parseResult.data;
        }
      }
    } catch (err: any) {
      console.error(err.message);
      errorContent.value = err.message;
    } finally {
      loadingContent.value = false;
    }
  }
});

async function onIgvRequest() {
  // validate
  if (!isIgv.value || !props.dataObject.name) {
    console.error('Not a BAM or VCF file, or missing file name');
    return;
  }
  // TODO: request new short-lived download URL (valid 1-4 hours, specify purpose as "igv")
  // get path from props.dataObject.name (e.g. folder1/folder2/ from the folder1/folder2/file.bam)
  const filePath = props.dataObject.name.split('/').slice(0, -1).join('/');

  // get file name without extenstion and path
  const baseFileName = props.dataObject.name
    .split('/')
    .pop()
    ?.split('.')
    .slice(0, -1)
    .join('.');

  // set names of BAM, BAI, VCF, TBI files
  const fileBam = `${filePath}/${baseFileName}.bam`;
  const fileVcf = `${filePath}/${baseFileName}.vcf`;
  const fileBai = `${filePath}/${baseFileName}.bam.bai`;

  // check file exists in the same bucket
  const exp_mins = 60; // 1 hour
  const q_params = { alt: 'media' };
  const purpose = localIgvUrlSelected.value ? 'igv-desktop' : 'igv-web';

  const urlBam = await getFileDownloadUrl(
    props.bucketId,
    fileBam,
    exp_mins,
    q_params,
    purpose
  );
  const urlVcf = await getFileDownloadUrl(
    props.bucketId,
    fileVcf,
    exp_mins,
    q_params,
    purpose
  );
  const urlBai = await getFileDownloadUrl(
    props.bucketId,
    fileBai,
    exp_mins,
    q_params,
    purpose
  );

  // check mandatory files are available
  if (!urlBam || !urlBai) {
    console.error('No BAM/BAI file available');
    alert(
      'No BAM/BAI file available. Please contact technical support for assistance.'
    );
    return;
  }
  // check optional files are available
  if (!urlVcf) {
    console.warn(
      'No VCF file available. You can still proceed with BAM/BAI only.'
    );
  }

  // Configure IGV URL and Search Params
  const requestBam = new URL(igvUrl.value);
  requestBam.searchParams.set('genome', igvGenome.value); // Genome is required
  requestBam.searchParams.set('file', urlBam); // BAM file is required
  requestBam.searchParams.set('index', urlBai); // BAI index is required
  if (igvLocus.value) requestBam.searchParams.set('locus', igvLocus.value); // Locus is optional

  // IGV Desktop selected
  if (localIgvUrlSelected.value) {
    // First Request for BAM (always)
    callIgvDesktopSilently(requestBam, 'igv-bam');

    // Second Request for VCF (if IGV Desktop & VCF available, file and index only)
    if (urlVcf) {
      const requestVcf = new URL(igvUrl.value);
      requestVcf.searchParams.set('file', urlVcf); // VCF file is required
      callIgvDesktopSilently(requestVcf, 'igv-vcf');
    }
  }

  // Additional info if IGV Web selected
  if (remoteIgvUrlSelected.value) {
    // IGV WEB: open BAM with index only
    window.open(requestBam.toString(), '_blank');
    // Instructions for additional tracks
    if (urlVcf) {
      igvAdditionalUrls.value.push({ value: urlVcf, text: 'VCF' });
    }
  }
}

function callIgvDesktopPrimary(url: URL, iFrameId: string) {
  // create/reuse a hidden iframe
  let iframe = document.getElementById(iFrameId) as HTMLIFrameElement | null;
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = iFrameId;
    Object.assign(iframe.style, {
      width: '0px',
      height: '0px',
      border: '0',
      position: 'absolute',
      left: '-9999px',
      top: '-9999px',
    });
    document.body.appendChild(iframe);
  }
  iframe.src = url.toString();
}

function callIgvDesktopFallback(url: URL) {
  // create a hidden image to call the URL
  const img = new Image();
  img.width = 1;
  img.height = 1;
  img.style.position = 'absolute';
  img.style.left = '-9999px';
  img.src = url.toString(); // fires the GET without opening a tab

  // optional cleanup
  setTimeout(() => {
    if (img.parentNode) img.parentNode.removeChild(img);
  }, 5000);

  document.body.appendChild(img);
}

function callIgvDesktopSilently(url: URL, id: string) {
  try {
    // Try iframe first (fast + quiet)
    callIgvDesktopPrimary(url, id);
  } catch {
    // Fallback to image beacon if iframe is blocked as mixed content
    console.warn('IGV Desktop iframe blocked, trying fallback method');
    callIgvDesktopFallback(url);
  }
  // As last resort (if both are blocked), you *could* fallback to window.open(url),
  // but only after showing a small prompt explaining why.
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal,
      class: _normalizeClass({ 'modal-xl': previewEmbedded.value, 'modal-lg': isIgv.value })
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "file-lines",
          class: "me-2"
        }),
        _createTextVNode(" " + _toDisplayString(_unref(formatFileName)(__props.dataObject.name)), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(BAlert), {
          modelValue: errorContent.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((errorContent).value = $event)),
          variant: "danger"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(errorContent.value), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (__props.dataObject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (
            __props.dataObject.size || __props.dataObject.contentType || __props.dataObject.updatedAt
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (__props.dataObject.size)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                          _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Size:", -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(formatFileSize)(__props.dataObject.size)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.dataObject.contentType)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                          _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Content Type:", -1)),
                          _createTextVNode(" " + _toDisplayString(__props.dataObject.contentType), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (__props.dataObject.updatedAt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                          _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Updated:", -1)),
                          _createTextVNode(" " + _toDisplayString(_unref(formatDateTime)(__props.dataObject.updatedAt)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (loadingContent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(BSpinner), { label: "Loading content..." })
                  ]))
                : (downloadUrl.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (isIgv.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[37] || (_cache[37] = _createElementVNode("p", { class: "mb-0" }, [
                              _createTextVNode(" You may open this file in the "),
                              _createElementVNode("strong", null, "IGV (Integrative Genomics Viewer)"),
                              _createTextVNode(" viewer. IGV is not operated by Sampling Human Inc. Your data will be provided directly from your cloud storage via a temporary link. ")
                            ], -1)),
                            _createVNode(_unref(BFormGroup), { class: "mb-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", _hoisted_8, [
                                  _cache[18] || (_cache[18] = _createTextVNode(" IGV Instance ", -1)),
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', 'question-circle'],
                                    class: "ms-2 text-secondary",
                                    id: "igv-url-help-icon"
                                  }),
                                  _createVNode(_unref(BTooltip), { target: "igv-url-help-icon" }, {
                                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                      _createTextVNode("Label to help you identify the reconstruction run later. ", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_unref(BFormSelect), {
                                  id: "igv-url-select",
                                  modelValue: igvUrl.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((igvUrl).value = $event)),
                                  options: igvUrlOptions.value,
                                  required: ""
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(BAlert), {
                              modelValue: remoteIgvUrlSelected.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remoteIgvUrlSelected).value = $event)),
                              variant: "danger",
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("p", { class: "fw-bold" }, " Proceed only if sharing this dataset with a third party complies with your legal/regulatory obligations and institutional policies. Do not use this option for PHI or identifiable data unless you (or your organization) have an appropriate agreement with the IGV operator permitting such use. ", -1),
                                _createElementVNode("p", null, " By continuing, you accept that Sampling Human Inc. is not responsible for IGV or any handling of your data by that service. ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (localIgvUrlSelected.value && !showIgvDesktopInstructions.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_unref(BButton), {
                                    variant: "link",
                                    class: "p-0 mb-0 text-decoration-none text-secondary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showIgvDesktopInstructions.value = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "info-circle",
                                        class: "me-1"
                                      }),
                                      _cache[20] || (_cache[20] = _createTextVNode(" Show IGV Desktop Instructions & Troubleshooting Tips ", -1))
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (localIgvUrlSelected.value && showIgvDesktopInstructions.value)
                              ? (_openBlock(), _createBlock(_unref(BAlert), {
                                  key: 1,
                                  modelValue: showIgvDesktopInstructions.value,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showIgvDesktopInstructions).value = $event)),
                                  variant: "info",
                                  class: "mb-0",
                                  dismissible: ""
                                }, {
                                  default: _withCtx(() => [
                                    _cache[31] || (_cache[31] = _createElementVNode("h5", { class: "mb-3" }, " IGV Desktop Instructions & Troubleshooting Tips ", -1)),
                                    _createElementVNode("ol", null, [
                                      _cache[28] || (_cache[28] = _createElementVNode("li", null, [
                                        _createElementVNode("strong", null, "Install IGV Desktop"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" Download and install IGV for your OS from the official "),
                                        _createElementVNode("a", {
                                          href: "https://igv.org/doc/desktop/#DownloadPage/",
                                          target: "_blank"
                                        }, "IGV Desktop downloads page.")
                                      ], -1)),
                                      _cache[29] || (_cache[29] = _createElementVNode("li", null, [
                                        _createElementVNode("strong", null, "Enable the local control port"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" Open "),
                                        _createElementVNode("strong", null, "IGV"),
                                        _createTextVNode(" → "),
                                        _createElementVNode("strong", null, "View"),
                                        _createTextVNode(" → "),
                                        _createElementVNode("strong", null, "Preferences"),
                                        _createTextVNode(" → "),
                                        _createElementVNode("strong", null, "Advanced"),
                                        _createTextVNode(" → check "),
                                        _createElementVNode("strong", null, "Enable port"),
                                        _createTextVNode(" and leave it at "),
                                        _createElementVNode("strong", null, "60151"),
                                        _createTextVNode(" (default). ")
                                      ], -1)),
                                      _createElementVNode("li", null, [
                                        _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Keep IGV running Leave IGV Desktop open", -1)),
                                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                                        _cache[24] || (_cache[24] = _createTextVNode(" When you click ", -1)),
                                        _createVNode(_unref(BBadge), { variant: "primary" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_font_awesome_icon, {
                                              icon: "eye",
                                              class: "me-1"
                                            }),
                                            _cache[21] || (_cache[21] = _createTextVNode("Proceed to IGV", -1))
                                          ]),
                                          _: 1
                                        }),
                                        _cache[25] || (_cache[25] = _createTextVNode(" here, we'll send a command to ", -1)),
                                        _cache[26] || (_cache[26] = _createElementVNode("code", null, "http://127.0.0.1:60151", -1)),
                                        _cache[27] || (_cache[27] = _createTextVNode(" to load your data. If IGV isn't running or the port isn't enabled, nothing will happen. ", -1))
                                      ]),
                                      _cache[30] || (_cache[30] = _createElementVNode("li", null, [
                                        _createElementVNode("strong", null, " IGV will fetch your data directly over HTTPS"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" Matching index files (e.g. BAM+BAI, VCF+TBI) will be automatically provided if they exist. ")
                                      ], -1))
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            (remoteIgvUrlSelected.value)
                              ? (_openBlock(), _createBlock(_unref(BFormCheckbox), {
                                  key: 2,
                                  modelValue: igvNoPhiConfirmed.value,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((igvNoPhiConfirmed).value = $event)),
                                  class: "mb-0"
                                }, {
                                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                    _createTextVNode(" I confirm this dataset is de-identified / not PHI. ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(BFormGroup), {
                              label: "Genome",
                              "label-for": "genome-select",
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(BFormSelect), {
                                  id: "genome-select",
                                  modelValue: igvGenome.value,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((igvGenome).value = $event)),
                                  options: igvGenomeOptions.value,
                                  required: ""
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(BFormGroup), {
                              label: "Locus (optional)",
                              "label-for": "locus-select",
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(BFormInput), {
                                  id: "locus-select",
                                  modelValue: igvLocus.value,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((igvLocus).value = $event)),
                                  placeholder: "Gene name like BRCA1, coordinates like chr1:1-1000000, or all",
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(BButton), {
                              onClick: onIgvRequest,
                              disabled: !igvNoPhiConfirmed.value && igvUrl.value === igvRemoteUrl,
                              variant: igvUrl.value === igvRemoteUrl ? 'danger' : 'primary'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "eye",
                                  class: "me-1"
                                }),
                                _cache[33] || (_cache[33] = _createTextVNode(" Proceed to IGV ", -1))
                              ]),
                              _: 1
                            }, 8, ["disabled", "variant"]),
                            _createVNode(_unref(BAlert), {
                              modelValue: showIgvAdditionalUrls.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showIgvAdditionalUrls).value = $event)),
                              variant: "info",
                              class: "mb-0"
                            }, {
                              default: _withCtx(() => [
                                _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "mb-3" }, " Instructions for loading additional tracks to IGV Web ", -1)),
                                _cache[36] || (_cache[36] = _createElementVNode("p", null, [
                                  _createTextVNode(" Only BAM and BAI files can be loaded automatically. Additional tracks need to be added manually in the "),
                                  _createElementVNode("strong", null, "IGV Web UI"),
                                  _createTextVNode(" → "),
                                  _createElementVNode("strong", null, "Tracks"),
                                  _createTextVNode(" → "),
                                  _createElementVNode("strong", null, "URL"),
                                  _createTextVNode(". You may add the following tracks: ")
                                ], -1)),
                                _createElementVNode("ol", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(igvAdditionalUrls.value, (url) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: url.value
                                    }, [
                                      _createElementVNode("strong", null, _toDisplayString(url.text) + ":", 1),
                                      _cache[34] || (_cache[34] = _createTextVNode()),
                                      _createElementVNode("code", null, _toDisplayString(url.value), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(BButton), {
                        href: downloadUrl.value,
                        target: "_blank",
                        variant: "primary"
                      }, {
                        default: _withCtx(() => [
                          (canPreviewInNewTab.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "eye",
                                  class: "me-1"
                                }),
                                _cache[38] || (_cache[38] = _createTextVNode(" Preview in new tab ", -1))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "download",
                                  class: "me-1"
                                }),
                                _cache[39] || (_cache[39] = _createTextVNode(" Download ", -1))
                              ], 64))
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      (previewEmbedded.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (isImageFile.value && downloadUrl.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("img", {
                                    src: downloadUrl.value,
                                    alt: "Image content",
                                    style: {"max-width":"100%","max-height":"80vh"}
                                  }, null, 8, _hoisted_12)
                                ]))
                              : (isDelimitedFile.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_unref(BPagination), {
                                      modelValue: pagingPageCurrent.value,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((pagingPageCurrent).value = $event)),
                                      "total-rows": pagingTotalRows.value,
                                      "per-page": pagingItemsPerPage.value,
                                      pills: "",
                                      size: "sm",
                                      "first-number": "",
                                      "last-number": ""
                                    }, null, 8, ["modelValue", "total-rows", "per-page"]),
                                    _createVNode(_unref(BForm), {
                                      class: "d-flex flex-row align-items-end flex-wrap mt-1",
                                      onSubmit: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"]))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(BFormGroup), {
                                          label: "Current page",
                                          "label-for": "current-page",
                                          "label-size": "sm",
                                          class: "me-3 mt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(BFormInput), {
                                              id: "current-page",
                                              name: "current-page",
                                              modelValue: pagingPageCurrent.value,
                                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((pagingPageCurrent).value = $event)),
                                              modelModifiers: { number: true },
                                              type: "number",
                                              size: "sm"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(BFormGroup), {
                                          label: "Items per page",
                                          "label-for": "items-per-page",
                                          "label-size": "sm",
                                          class: "me-3 mt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(BFormInput), {
                                              id: "items-per-page",
                                              name: "items-per-page",
                                              modelValue: pagingItemsPerPage.value,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((pagingItemsPerPage).value = $event)),
                                              modelModifiers: { number: true },
                                              size: "sm"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_14, [
                                      _createVNode(_unref(BTable), {
                                        items: paginatedItems.value,
                                        fields: parsedFields.value,
                                        striped: "",
                                        small: "",
                                        hover: "",
                                        responsive: "",
                                        class: "browser-table mt-4"
                                      }, null, 8, ["items", "fields"])
                                    ])
                                  ]))
                                : (isJson.value)
                                  ? (_openBlock(), _createElementBlock("pre", {
                                      key: 2,
                                      class: "code-highlight",
                                      innerHTML: _unref(highlightJson)(formattedJson.value)
                                    }, null, 8, _hoisted_15))
                                  : (isPython.value)
                                    ? (_openBlock(), _createElementBlock("pre", {
                                        key: 3,
                                        class: "code-highlight",
                                        innerHTML: _unref(highlightPython)(fileContent.value)
                                      }, null, 8, _hoisted_16))
                                    : (isLog.value)
                                      ? (_openBlock(), _createElementBlock("pre", {
                                          key: 4,
                                          class: "code-highlight",
                                          innerHTML: _unref(highlightLog)(fileContent.value)
                                        }, null, 8, _hoisted_17))
                                      : (isShell.value)
                                        ? (_openBlock(), _createElementBlock("pre", {
                                            key: 5,
                                            class: "code-highlight",
                                            innerHTML: _unref(highlightShell)(fileContent.value)
                                          }, null, 8, _hoisted_18))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(fileContent.value), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "class"])
  ]))
}
}

})